(function () {
  var modal = document.querySelector('[data-rng-mailchimp-modal]');
  if (!modal) return;

  var form = modal.querySelector('[data-rng-mailchimp-form]');
  var emailInput = modal.querySelector('[data-rng-mailchimp-email]');
  var emailLabel = modal.querySelector('[data-rng-mailchimp-email-label]');
  var titleEl = modal.querySelector('[data-rng-mailchimp-title]');
  var descriptionEl = modal.querySelector('[data-rng-mailchimp-description]');
  var submitTextEls = modal.querySelectorAll('[data-rng-mailchimp-submit-text]');
  var botWrap = modal.querySelector('[data-rng-mailchimp-bot-wrap]');
  var mergeWrap = modal.querySelector('[data-rng-mailchimp-merge-wrap]');
  var closeButtons = modal.querySelectorAll('[data-rng-mailchimp-close]');

  function setHiddenField(wrap, name, value) {
    wrap.innerHTML = '';
    wrap.hidden = true;

    if (!name) return;

    var input = document.createElement('input');
    input.type = name.indexOf('b_') === 0 ? 'text' : 'hidden';
    input.name = name;
    input.value = value || '';

    if (name.indexOf('b_') === 0) {
      input.tabIndex = -1;
      wrap.setAttribute('aria-hidden', 'true');
      wrap.style.position = 'absolute';
      wrap.style.left = '-5000px';
    }

    wrap.appendChild(input);
    wrap.hidden = false;
  }

  function openModal(trigger) {
    var actionUrl = trigger.getAttribute('data-mailchimp-action-url');
    if (!actionUrl || !form) return;

    form.action = actionUrl;

    var placeholder = trigger.getAttribute('data-mailchimp-placeholder') || 'Email address';
    var buttonLabel = trigger.getAttribute('data-mailchimp-button-label') || 'Notify me';
    var modalTitle = trigger.getAttribute('data-mailchimp-modal-title') || 'Get notified';
    var modalDescription = trigger.getAttribute('data-mailchimp-modal-description') || '';
    var botField = trigger.getAttribute('data-mailchimp-bot-field') || '';
    var mergeFieldName = trigger.getAttribute('data-mailchimp-merge-field-name') || '';
    var mergeFieldValue = trigger.getAttribute('data-mailchimp-merge-field-value') || '';

    if (titleEl) titleEl.textContent = modalTitle;
    submitTextEls.forEach(function (el) {
      el.textContent = buttonLabel;
    });
    if (emailInput) {
      emailInput.placeholder = placeholder;
      emailInput.value = '';
    }
    if (emailLabel) emailLabel.textContent = placeholder;

    if (descriptionEl) {
      if (modalDescription) {
        descriptionEl.textContent = modalDescription;
        descriptionEl.hidden = false;
      } else {
        descriptionEl.textContent = '';
        descriptionEl.hidden = true;
      }
    }

    setHiddenField(botWrap, botField, '');
    setHiddenField(mergeWrap, mergeFieldName, mergeFieldValue);

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    if (emailInput) {
      window.setTimeout(function () {
        emailInput.focus();
      }, 50);
    }
  }

  function closeModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rng-mailchimp-open]');
    if (!trigger) return;

    event.preventDefault();
    openModal(trigger);
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });

  if (form) {
    form.addEventListener('submit', function () {
      window.setTimeout(closeModal, 100);
    });
  }
})();
